import React, { useEffect, useReducer } from "react";
import { CircularsContainer } from "./style";
import { Container } from "react-bootstrap";
import { getAnnouncements } from "../../api/init";

const initialState = {
    loading: true,
    activeList: [],
    expiredList: [],
};

function reducer(state, action) {
    switch (action.type) {
        case "SET_INIT_DATA":
            return {
                ...state,
                ...action.payload,
                loading: false,
            };
        case "TOGGLE_LOADING":
            return { ...state, loading: !state.loading };
        default:
            return state;
    }
}

const Circulars = () => {
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        let cancelled = false;

        const fetchData = async () => {
            try {
                const res = await getAnnouncements();
                if (!cancelled) {
                    dispatch({
                        type: "SET_INIT_DATA",
                        payload: {
                            activeList: res?.data?.active ?? [],
                            expiredList: res?.data?.expired ?? [],
                        },
                    });
                }
            } catch (err) {
                if (!cancelled) {
                    dispatch({ type: "TOGGLE_LOADING" });
                }
            }
        };

        fetchData();

        return () => {
            cancelled = true;
        };
    }, []); // <- important: run once on mount

    if (state.loading) {
        return (
            <CircularsContainer>
                <Container>
                    <p>...</p>
                </Container>
            </CircularsContainer>
        );
    }

    return (
        <CircularsContainer>
            <Container>
                {state.activeList.length > 0 && (
                    <div>
                        <h1>بخشنامه ها</h1>
                        <div className="items">
                            {state.activeList.map((item) => (
                                <a
                                    key={item.url}
                                    href={item.url}
                                    target="_blank"
                                    className="item"
                                    rel="noopener noreferrer"
                                >
                                    {item.title}
                                </a>
                            ))}
                        </div>
                    </div>
                )}

                {state.expiredList.length > 0 && (
                    <>
                        <br />
                        <br />
                        <br />
                        <div>
                            <h1>بخشنامه های منقضی شده</h1>
                            <div className="items">
                                {state.expiredList.map((item) => (
                                    <a
                                        key={item.url}
                                        href={item.url}
                                        target="_blank"
                                        className="item"
                                        rel="noopener noreferrer"
                                    >
                                        {item.title}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </>
                )}
            </Container>
        </CircularsContainer>
    );
};

export default Circulars;
